import type { ComponentProps, ReactNode } from 'react'

import { Typography } from '../typography'

import type { HeadlineSize } from './headline'
import * as styles from './headline-subtitle.styles'
import { useSize } from './size-context'

type Props = {
  children: ReactNode
  variant?: 'default' | 'md'
  className?: string
}
export const HeadlineSubtitle = ({
  children,
  className,
  variant: stylesVariant = 'default',
}: Props) => {
  const mainSize = useSize()

  const variant: Record<HeadlineSize, ComponentProps<typeof Typography>['variant']> = {
    large: 'b1',
    default: 'b2',
    xl: 'b2',
  }

  return (
    <Typography
      className={className}
      color="textSecondary"
      css={styles.text[stylesVariant]}
      data-testid="headline-subtitle"
      variant={variant[mainSize]}
    >
      {children}
    </Typography>
  )
}
